import { render, staticRenderFns } from "./Invoice.vue?vue&type=template&id=0a0818bc&scoped=true"
import script from "./Invoice.vue?vue&type=script&lang=js"
export * from "./Invoice.vue?vue&type=script&lang=js"
import style0 from "./Invoice.vue?vue&type=style&index=0&id=0a0818bc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0818bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a0818bc')) {
      api.createRecord('0a0818bc', component.options)
    } else {
      api.reload('0a0818bc', component.options)
    }
    module.hot.accept("./Invoice.vue?vue&type=template&id=0a0818bc&scoped=true", function () {
      api.rerender('0a0818bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/Invoice.vue"
export default component.exports